<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "AgencyContestViewTemplate",
	};
</script>

<style scoped>

</style>
